import { LineChartGraph } from '@/common/components/LineChart'

interface GraphData {
	week: string
	activeUsers: number
	firstDeposits: number
	newUsers: number
	[key: string]: string | number
}

interface UserSummaryGraphProps {
	data: GraphData[]
}

export default function UserSummaryGraph({ data }: UserSummaryGraphProps) {
	const last7DaysData = data.slice(-7)

	return (
		<LineChartGraph
			data={last7DaysData}
			title="ยอดผู้ใช้งาน 7 วันล่าสุด"
			description="แสดงข้อมูล 7 วันล่าสุด"
			dataKeys={{
				activeUsers: {
					label: 'Active Users',
					color: '#c200fb',
				},
				firstDeposits: {
					label: 'ฝากครั้งแรกภายในการสมัคร',
					color: '#fbfb00',
				},
				newUsers: {
					label: 'New Users',
					color: '#fb0b00',
				},
			}}
		/>
	)
}
